import Accordion, { AccordionElement } from "./Accordion";

export default Accordion;
export { AccordionElement };
